import initGtag from './gtag';

const init = (config: any) => {
  initGtag(config);
};

export default {
  init,
};
